import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { createTemperature } from '../thunk';

import type { TemperatureInputType } from '@/domain/temperature/component/TemperatureFormInput';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';
import type { UserType } from '@/types/domain/user/redux';

import DialogTitle from '@/components/DialogTitle';
import TemperatureFormInput from '@/domain/temperature/component/TemperatureFormInput';
import { parseTimeByCurrentDate, toStringTime } from '@/utils/date';

/** プロパティ */
export type AddTemperatureInput = {
  /** 開くか */
  isOpen: boolean,
  /** 閉じる */
  close: () => void,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
  /** 施設リスト */
  facilityList: FacilityJson[],
  /** 日付 */
  date?: Date,
};

const AddTemperature: React.FC<AddTemperatureInput> = ({
  isOpen,
  close,
  user,
  child,
  facilityList,
  date,
}) => {
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<TemperatureInputType>({
    defaultValues: {
      temperature: '36.5',
      measureDateTime: toStringTime(new Date(), false),
    },
  });
  const onSubmit = (input: TemperatureInputType) => {
    const username = user.name;
    const temperature = parseFloat(input.temperature);
    dispatch(createTemperature({
      data: {
        data: {
          measureDateTime: parseTimeByCurrentDate(input.measureDateTime, date).toJSON(),
          temperature,
          measurerId: username,
          measurerType: 'app',
          parentId: username,
          childId: child.childId,
        },
        pub: {
          sendId: `${child.parentId}_${child.childId}`,
          replyId: username,
          data: {},
        },
      },
      facilityIds: facilityList.map((v) => v.data.facilityId),
    }));
    close();
  };
  return (
    <Dialog
      open={isOpen}
      onClose={() => close()}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ minWidth: '300px' }}
      >
        <DialogTitle title="体温の登録" />
        <DialogContent>
          <TemperatureFormInput
            control={control}
            errors={errors}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            type="submit"
            color="primary"
          >
            登録する
          </Button>
          <Button
            variant="contained"
            onClick={() => close()}
            color="primary"
          >
            閉じる
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddTemperature;
